import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Message from './ValidationMessage';
import InlineField from './InlineField';
import { getParticularPreferenceSettings } from '../../../../common/selectors/preference';

class DatePickerMin extends Component {
  render() {
    let {
      intl,
      translation,
      input,
      label,
      maxDate = {},
      required,
      disabled,
      isClearable = true,
      displayType,
      dateFormat,
      meta: { touched, error, warning },
    } = this.props;
    if (intl && translation) {
      const labelObj = translation.label;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    let date = null;
    const inputValue = input.value;
    let maximumDate = {};

    let showError = touched && error ? 'error' : '';

    if (typeof inputValue === 'string' && inputValue.length > 0) {
      date = moment(inputValue);
    }
    if (typeof inputValue === 'object') {
      date = inputValue;
    }

    if (typeof maxDate === 'string' && maxDate.length > 0) {
      maximumDate = moment(maxDate);
    }
    if (typeof maxDate === 'object') {
      maximumDate = maxDate;
    }

    const selected = date && { selected: date };
    input.value = date;

    if (displayType === 'inline') {
      return (
        <InlineField
          fieldType='renderPickerMinField'
          content={date ? intl.formatDate(date) : null}
          label={label}
        />
      );
    }

    return (
      <div className={`${required && 'required'} field ${showError}`}>
        <label>{label}</label>
        <DatePicker
          {...input}
          isClearable={isClearable}
          disabled={disabled}
          required={required}
          maxDate={maximumDate}
          dateFormat={dateFormat}
          {...selected}
        />
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const dateFormat = (
    getParticularPreferenceSettings(state, 'date_format', ['value']) || {}
  ).value;

  return {
    dateFormat,
  };
};

export const DatePickerMinField = connect(mapStateToProps)(DatePickerMin);
